import { useMemo } from 'react';

import { useFormState } from 'react-final-form';
import {
  ControlWithDescription,
  InlineWithDescription,
} from 'components/form-layouts';

import { getMigPartitionsByInstanceType } from '../../_utils';

import { ProvisionNodesCloudConfigurationFormValues } from '../../types';
import { RffSelect } from '@cast/shared-rff-ui';

import { Stack } from '@cast/design-system';

type MultiInstanceGpuSectionProps = {
  disabled: boolean;
  hint?: string;
};

export const MultiInstanceGpuSection = ({
  disabled,
  hint,
}: MultiInstanceGpuSectionProps) => {
  const { values } = useFormState<ProvisionNodesCloudConfigurationFormValues>({
    subscription: { values: true },
  });
  const { instanceType } = values;

  const partitionSizeOptions = instanceType
    ? getMigPartitionsByInstanceType(instanceType)
    : [];

  const partitionSizeHint = useMemo(() => {
    if (hint) {
      return hint;
    }

    if (!instanceType) {
      return 'Select instance type first.';
    }

    if (partitionSizeOptions.length === 0) {
      return "The selected instance type doesn't support MIG.";
    }

    return undefined;
  }, [hint, instanceType, partitionSizeOptions.length]);

  return (
    <InlineWithDescription
      description={
        <Stack gap={4}>
          <ControlWithDescription label="Multi-instance GPU (MIG)">
            Partition the GPU into isolated slices with dedicated memory.
          </ControlWithDescription>
        </Stack>
      }
      controls={
        <RffSelect
          name="partitionSize"
          label="Partition sizes"
          inputProps={{
            placeholder: 'Select partition size',
            hint: partitionSizeHint,
          }}
          options={partitionSizeOptions}
          disabled={disabled || partitionSizeOptions.length === 0}
          testId="partition-size-select"
        />
      }
    />
  );
};
